import { FC, useEffect } from 'react';
import { Link } from '@tanstack/react-router';
import { Button } from '@glomopay/shadcn/button';

import { analytics, AnalyticsEventName, PageName } from '@/features/analytics/public';

export const NotFoundPage: FC = () => {
  useEffect(() => {
    analytics.track(AnalyticsEventName.INVESTOR_PAGE_VIEWED, { page_name: PageName.NOT_FOUND });
  }, []);

  return (
    <main className='bg-bg-default flex min-h-dvh flex-col items-center justify-center gap-6 px-6 text-center'>
      <h1 className='text-text-primary text-6xl font-semibold'>OOPS! 404</h1>
      <p className='text-text-secondary'>We could not find what you were looking for</p>
      <Button asChild>
        <Link to='/'>Go Back Home</Link>
      </Button>
    </main>
  );
};
